import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';

export const GET_USER_ROLES = '@taxRate/get-user-roles';
export const REQUEST_USER_ROLES = '@taxRate/request-user-roles';

export function getUserRoles() {
  const request = axios.get(`${API_BASE_URL}/user/role`);

  return (dispatch) => {
    dispatch({ type: REQUEST_USER_ROLES });

    request
      .then((response) =>
        dispatch({
          type: GET_USER_ROLES,
          payload: { userRoles: response.data }
        })
      )
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = error.response.data;
        }
        dispatch({
          type: GET_USER_ROLES,
          payload: { userRoles: [], message }
        });
      });
  };
}
